import { Slide } from '@features/powerpoint';
import {
  campaignInsightsCoverSlide,
  audienceProfileSlide,
  demographicProfileSlide,
  moreStatsSlide,
} from '.';
import { BuildReportOptions } from '../utils/build-presentation';
import { topStatesDmasLocationsSlide } from './top-states-dmas-locations';
import { visitorProfileSlide } from './visitor-profile';
import { visibleSlide } from '@features/executive-report/slides';
import {
  moreStatsSlideVisible,
  topStatesDmasLocationsSlideVisible,
  visitorProfileSlideVisible,
} from '../domain/campaign-insights-slides';

export const campaignInsightsSlides = (
  campaignAnalyticsReport: BuildReportOptions['campaignAnalyticsReport'],
  includedSlides: BuildReportOptions['customFields']['includedSlides']['campaignInsights']
): Slide[] => {
  if (!campaignAnalyticsReport) return [];

  return [
    ...visibleSlide({
      slide: campaignInsightsCoverSlide(),
      visible: includedSlides.cover,
    }),
    ...visibleSlide({
      visible:
        campaignAnalyticsReport.audienceProfile.visible &&
        includedSlides.audienceProfile,
      slide: audienceProfileSlide({
        audienceProfile: campaignAnalyticsReport.audienceProfile,
      }),
    }),
    ...visibleSlide({
      visible:
        campaignAnalyticsReport.demographicProfile.visible &&
        includedSlides.demographicProfile,
      slide: demographicProfileSlide({
        demographicProfile: campaignAnalyticsReport.demographicProfile,
      }),
    }),
    ...visibleSlide({
      visible:
        topStatesDmasLocationsSlideVisible(campaignAnalyticsReport) &&
        includedSlides.topLocations,
      slide: topStatesDmasLocationsSlide({
        stateVisits: campaignAnalyticsReport.stateVisits,
        dmaVisits: campaignAnalyticsReport.dmaVisits,
        brandLocationVisits: campaignAnalyticsReport.brandLocationVisits,
      }),
    }),
    ...visibleSlide({
      visible:
        moreStatsSlideVisible(campaignAnalyticsReport) &&
        includedSlides.moreStats,
      slide: moreStatsSlide({
        proximityToHome: campaignAnalyticsReport.proximityToHome,
        visitsByHourOfDay: campaignAnalyticsReport.visitsByHourOfDay,
        visitsByDayOfWeek: campaignAnalyticsReport.visitsByDayOfWeek,
        timeToFirstVisitByDay: campaignAnalyticsReport.timeToFirstVisitByDay,
      }),
    }),
    ...visibleSlide({
      visible:
        visitorProfileSlideVisible(campaignAnalyticsReport) &&
        includedSlides.visitorProfile,
      slide: visitorProfileSlide(campaignAnalyticsReport),
    }),
  ];
};
